export function initNavMenu() {
  const toggle = document.querySelector('[data-menu-toggle]')
  const panel = document.querySelector('[data-menu-panel]')
  if (!toggle || !panel) return

  function setOpen(open) {
    panel.hidden = !open
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    toggle.classList.toggle('menu-pill--open', open)
  }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation()
    setOpen(panel.hidden)
  })
  document.addEventListener('click', function (e) {
    if (
      !panel.hidden &&
      !panel.contains(e.target) &&
      !toggle.contains(e.target)
    ) {
      setOpen(false)
    }
  })
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false)
  })
}
